import { render, staticRenderFns } from "./SelloMovimiento.vue?vue&type=template&id=13b91433"
import script from "./SelloMovimiento.vue?vue&type=script&lang=js"
export * from "./SelloMovimiento.vue?vue&type=script&lang=js"
import style0 from "./SelloMovimiento.vue?vue&type=style&index=0&id=13b91433&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports